export const langCodes = {
  en_US: 'en-US',
  en_CA: 'en-CA',
  en_AU: 'en-AU',
  // Never a build's `siteSettings.lang`: the Canadian build read through MotionPoint's `fr.` proxy host.
  fr_CA: 'fr-CA',
} as const
